var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPortalLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8118 49.6769C76.4554 59.1279 70.7314 67.3944 62.7137 72.9255C54.6961 78.4565 44.9357 80.8719 35.2638 79.7186C25.592 78.5653 16.6733 73.9225 10.181 66.6613C3.68867 59.4001 0.0689749 50.0194 0.000974769 40.2793C-0.0670254 30.5391 3.42134 21.1088 9.81162 13.7576C16.2019 6.40647 25.0549 1.63961 34.7097 0.351378C44.3646 -0.936851 54.1577 1.34208 62.2518 6.76062C70.3459 12.1792 76.1848 20.3649 78.6729 29.7822L40 40L78.8118 49.6769Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.8118 49.6769C76.4554 59.1279 70.7314 67.3944 62.7137 72.9255C54.6961 78.4565 44.9357 80.8719 35.2638 79.7186C25.592 78.5653 16.6733 73.9225 10.181 66.6613C3.68867 59.4001 0.0689749 50.0194 0.000974769 40.2793C-0.0670254 30.5391 3.42134 21.1088 9.81162 13.7576C16.2019 6.40647 25.0549 1.63961 34.7097 0.351378C44.3646 -0.936851 54.1577 1.34208 62.2518 6.76062C70.3459 12.1792 76.1848 20.3649 78.6729 29.7822L40 40L78.8118 49.6769Z",
    stroke: "black",
    strokeWidth: 11.4286,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5247 43.8708C54.5822 47.6512 52.2926 50.9578 49.0855 53.1702C45.8784 55.3826 41.9743 56.3488 38.1055 55.8874C34.2368 55.4261 30.6693 53.569 28.0724 50.6645C25.4755 47.76 24.0276 44.0078 24.0004 40.1117C23.9732 36.2156 25.3685 32.4435 27.9246 29.5031C30.4808 26.5626 34.022 24.6558 37.8839 24.1406C41.7458 23.6253 45.6631 24.5368 48.9007 26.7042C52.1384 28.8717 54.4739 32.146 55.4692 35.9129L40 40L55.5247 43.8708Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.5247 43.8708C54.5822 47.6512 52.2926 50.9578 49.0855 53.1702C45.8784 55.3826 41.9743 56.3488 38.1055 55.8874C34.2368 55.4261 30.6693 53.569 28.0724 50.6645C25.4755 47.76 24.0276 44.0078 24.0004 40.1117C23.9732 36.2156 25.3685 32.4435 27.9246 29.5031C30.4808 26.5626 34.022 24.6558 37.8839 24.1406C41.7458 23.6253 45.6631 24.5368 48.9007 26.7042C52.1384 28.8717 54.4739 32.146 55.4692 35.9129L40 40L55.5247 43.8708Z",
    stroke: "black",
    strokeWidth: 17.1429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V80H0V0Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPortalLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PortalLogo.3aba5da4.svg";
export { ForwardRef as ReactComponent };